import { render, staticRenderFns } from "./IndicadorInvestigadoresGrado.vue?vue&type=template&id=71fe34ee&scoped=true&"
import script from "./IndicadorInvestigadoresGrado.vue?vue&type=script&lang=js&"
export * from "./IndicadorInvestigadoresGrado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fe34ee",
  null
  
)

export default component.exports